<template>
  <div class="widget-business-summary">
    <div>
      <CalicoChip
        v-if="summary"
        text="Summary"
      />
      <CalicoChip
        v-else
        text="Coming Soon"
      />
    </div>
    <h1
      v-if="!summary"
      class="heading--large"
    >
      Generate a BetaScore <br> <em>for</em> a business
    </h1>
    <p class="body--large">
      {{ summary || 'Get the most out of BetaScore by providing information for new or existing clients.' }}
    </p>

    <div
      v-if="factors.length"
      class="top-factors"
    >
      <span class="line" />
      <label class="label--medium">
        Top Factors
      </label>
      <StoryCard
        v-for="([score, title, description], index) in factors"
        :key="index"
        :score="score"
        :title="title"
        :description="description"
      />
    </div>
    <div
      v-else
      class="no-score"
    >
      <div class="card">
        <label class="label--medium">
          For new/prospective clients
        </label>
        <CalicoIconCard>
          <i class="bi bi-brightness-alt-high-fill contained-icon-medium" />
          <h1 class="heading--xsmall">
            Confident loan decisioning
          </h1>
          <p class="body--medium">
            Kick off your lending process by adding new/prospective 
            clients’ financials through BetaScore. We’ll crunch the numbers 
            and—along with our unique data sources—compile the most 
            comprehensive credit profile for the business.
          </p>
        </CalicoIconCard>
      </div>
      <div class="card">
        <label class="label--medium">
          For existing clients
        </label>
        <CalicoIconCard>
          <i class="bi bi-lightning-charge contained-icon-medium" />
          <h1 class="heading--xsmall">
            Real time credit monitoring
          </h1>
          <p class="body--medium">
            Start tracking the financial health of your business clients 
            automatically and over time—especially useful for annual 
            credit reviews and/or changes to products or services.
          </p>
        </CalicoIconCard>
      </div>
    </div>
  </div>
</template>
    
<script>
import CalicoChip from '@/components/calico/chip/index.vue';
import StoryCard from '@/components/calico/storyCard/index.vue';
import CalicoIconCard from "@/components/calico/iconCard/index.vue";

export default {
  name: "TipWidget",
  components: {
    CalicoChip,
    StoryCard,
    CalicoIconCard
  },
  props: {
    summary: {
      type: String,
      default: ""
    },
    factors: {
      type: Array,
      default: () => []
    }
  },
};
</script>
    
<style scoped lang="scss">
.widget-business-summary {
  @include stack-space($space-large);
  padding: $space-xlarge $space-medium;
  p {
    margin: 0;
  }
  .top-factors, .no-score {
    @include stack-space($space-large);
    .line {
      width: auto;
      height: 1px;
      border-top: 1px dotted $color-neutral;
    }
    .card {
      @include stack-space($space-medium);
    }
    .view-all-factors {
      color: $color-tertiary-label;
    }
  }
  .contained-icon-medium {
    background: $color-green;
    border: $color-green;
  }
}
</style>